import React, { useRef } from 'react';
import cn from 'classnames';

import * as styles from './EyeAnimated.module.css';

const EyeAnimated = ({
  duration = '150ms',
  onClick,
  className,
  style,
  label
}) => {
  const paths = {
    open: {
      column: 'm15.465 3.535 3.17.021-.173 25.44-3.17-.022z',
      eye: 'm27.75 7.45.03-3.69L2.96 14.55l-.02 3.26 24.67 11.13.02-3.69-20.52-9.04 20.64-8.76z'
    },
    closed: {
      column: 'm16.036 13.729 3.17.021-.032 4.64-3.17-.021z',
      eye: 'm28.39 15.75.03-2.69L3.6 14.34l-.02 3.26 24.79 1.34.02-3.69L7.75 16l20.64-.25z'
    }
  };

  const columnOpenAnimation = useRef(null);
  const columnClosedAnimation = useRef(null);
  const eyeOpenAnimation = useRef(null);
  const eyeClosedAnimation = useRef(null);

  const closeAnimation = () => {
    columnClosedAnimation.current.beginElement();
    eyeClosedAnimation.current.beginElement();
  };

  const openAnimation = () => {
    columnOpenAnimation.current.beginElement();
    eyeOpenAnimation.current.beginElement();
  };

  const { column, eye } = paths.open;

  return (
    <button
      className={cn(styles.root, className)}
      style={style}
      onClick={onClick}
      aria-label={label}
      onMouseEnter={() => closeAnimation()}
      onMouseLeave={() => openAnimation()}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden>
        <path d={column}>
          <animate
            ref={columnOpenAnimation}
            begin="indefinite"
            attributeName="d"
            dur={duration}
            to={paths.open.column}
            fill="freeze"
          />
          <animate
            ref={columnClosedAnimation}
            begin="indefinite"
            attributeName="d"
            dur={duration}
            to={paths.closed.column}
            fill="freeze"
          />
        </path>
        <path d={eye}>
          <animate
            ref={eyeOpenAnimation}
            begin="indefinite"
            attributeName="d"
            dur={duration}
            to={paths.open.eye}
            fill="freeze"
          />
          <animate
            ref={eyeClosedAnimation}
            begin="indefinite"
            attributeName="d"
            dur={duration}
            to={paths.closed.eye}
            fill="freeze"
          />
        </path>
      </svg>
    </button>
  );
};

export default EyeAnimated;
